<template>
  <b-modal id="updateTaskParamsModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('views.excmtask.updateParams.title') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="path">
      <b-col>
        <UpdateTaskParams @reload="closeModal"></UpdateTaskParams>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UpdateTaskParams from '@/components/Dashboard/Views/excmtask/UpdateTaskParams'
export default {
  name: 'UpdateTaskParamsModal',
  components: {
    UpdateTaskParams
  },
  computed: {
    show () {
      return this.$store.state.modals.updateTaskParams.show
    },
    path () {
      return this.$store.state.modals.updateTaskParams.path
    },
    close () {
      return this.$store.state.modals.updateTaskParams.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'path': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      serviceman: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.path) {
        this.$store.state.modals.updateTaskParams.show = 0
        this.$bvModal.show('updateTaskParamsModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.updateTaskParams.close = 0
        this.$bvModal.hide('updateTaskParamsModal')
      }
    },
    resetData () {
      this.$store.state.modals.updateTaskParams.path = null
      this.$emit('reload')
    }
  }
}
</script>
